import React, { useEffect, useState } from "react";
import {
  MessageCircle,
  X,
} from "lucide-react";
import { useLocation } from "react-router-dom";
import { BluPayChat } from "../BluPayChat";

const CHAT_ENABLED_ROUTES = new Set([
  "/home",
  "/transactionhistory",
  "/fxcalculator",
]);

export function FloatingChatLauncher() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const isAllowed = CHAT_ENABLED_ROUTES.has(
    location.pathname
  );

  useEffect(() => {
    if (!isAllowed) {
      setIsOpen(false);
    }
  }, [isAllowed]);

  if (!isAllowed) {
    return null;
  }

  return (
    <>
      {/* BACKDROP */}
      {isOpen && (
        <button
          type="button"
          aria-label="Close BluPay chat"
          onClick={() => setIsOpen(false)}
          className="
            fixed inset-0 z-[70]
            bg-black/25
            backdrop-blur-[2px]
            md:bg-black/15
          "
        />
      )}

      {/* CHAT PANEL */}
      {isOpen && (
        <section
          role="dialog"
          aria-label="BluPay chat"
          aria-modal="true"
          className="
            fixed z-[80]

            inset-0

            md:inset-auto
            md:right-6
            md:bottom-6
            md:h-[min(860px,calc(100vh-3rem))]
            md:w-[min(760px,calc(100vw-3rem))]
            md:overflow-hidden
            md:rounded-[30px]
            md:border
            md:border-black/10
            md:bg-white
            md:shadow-2xl
          "
        >
          {/* CLOSE BUTTON */}
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            aria-label="Close chat"
            className="
              absolute right-4 top-4 z-[90]
              flex h-10 w-10
              items-center justify-center
              rounded-full
              bg-white/90
              text-[#0A4730]
              shadow-md
              backdrop-blur
              transition
              hover:scale-105
              hover:bg-white
              active:scale-95
            "
          >
            <X size={20} />
          </button>

          <BluPayChat embedded />
        </section>
      )}

      {/* SMALL FLOATING BUTTON */}
      {!isOpen && (
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          aria-label="Open BluPay chat"
          className="
            fixed
            right-5
            z-[60]

            bottom-[calc(6.5rem+env(safe-area-inset-bottom))]

            md:bottom-7
            md:right-7

            flex
            h-14
            w-14
            items-center
            justify-center

            rounded-full
            bg-[#0A4730]
            text-[#C0F6B7]

            shadow-[0_12px_35px_rgba(10,71,48,0.30)]

            transition-all
            duration-200

            hover:scale-105
            hover:shadow-[0_16px_40px_rgba(10,71,48,0.38)]

            active:scale-95
          "
        >
          <MessageCircle
            size={25}
            strokeWidth={2.3}
          />

          <span
            className="
              absolute
              right-0
              top-0
              h-3.5
              w-3.5
              rounded-full
              border-2
              border-white
              bg-[#C0F6B7]
            "
          />
        </button>
      )}
    </>
  );
}